module.exports = __webpack_public_path__ + "img/integrations-drupal.41cfcea5.png";